import { uploadProductsMinimumStockExcel } from '@gozoki/api'
import type { XlsxImportError } from '@gozoki/api-types'
import { useMutation } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { AxiosError } from 'axios'
import RbacAccessDeniedPage from '~/components/communication/RbacAccessDeniedPage'
import { Can } from '~/utils/ability'
import { XslxImport } from '../../../components/XslxImport'

export const Route = createFileRoute('/_authenticated/daily-sales/stock-min/import')({
  component: () => (
    <Can I="read" a="daily-sales" passThrough>
      {({ isAllowed }) => (isAllowed ? <ImportMinStockPage /> : <RbacAccessDeniedPage />)}
    </Can>
  ),
})

function ImportMinStockPage() {
  const { mutateAsync: mutateUploadMinimumStock } = useMutation({
    mutationFn: uploadProductsMinimumStockExcel,
  })

  return (
    <XslxImport
      onSubmit={async (file) => {
        try {
          const data = await mutateUploadMinimumStock(file)
          return { data }
        } catch (error) {
          if (error instanceof AxiosError) {
            return { error: error.response?.data as XlsxImportError }
          }
          return { error: { message: 'Une erreur inconnue est survenue', errors: [] } }
        }
      }}
      resourceName={{ singular: 'stock minimum', plural: 'stocks minimum' }}
      goBackRoute="/daily-sales"
    />
  )
}
